import { useState } from "react";

export default function PasswordGate({ children }) {
  const [authenticated, setAuthenticated] = useState(
    localStorage.getItem("lifely_access") === "granted"
  );
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === "linda2026") {
      localStorage.setItem("lifely_access", "granted");
      setAuthenticated(true);
    } else {
      setError(true);
    }
  };

  if (authenticated) {
    return children;
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-serif text-foreground mb-2">Lifely</h1>
          <p className="text-muted-foreground">Site under maintenance</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError(false);
            }}
            placeholder="Enter password"
            className="w-full px-4 py-3 rounded-lg border border-border bg-card text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          />
          {error && (
            <p className="text-red-500 text-sm">Incorrect password</p>
          )}
          <button
            type="submit"
            className="w-full px-4 py-3 rounded-lg bg-primary text-primary-foreground font-medium hover:opacity-90 transition-opacity"
          >
            Enter
          </button>
        </form>
      </div>
    </div>
  );
}
